export enum EnvNames {
    PROD = 'production',
    DEV = 'development',
  }
  type EnvName = EnvNames.PROD | EnvNames.DEV;
  
  export interface EnvConfig {
    apiURL: string;
    env: EnvName;
  }
  
  const ENV_CONFIGS: Record<EnvName, EnvConfig> = {
      production: {
        apiURL: (import.meta as any).env.VITE_APP_API_URL_PROD,
        env: EnvNames.PROD,
      },
      development: {
        apiURL: (import.meta as any).env.VITE_APP_API_URL_DEV,
        env: EnvNames.DEV,
      },
    };
  
  export function getEnvConfig(): EnvConfig {
    const nodeEnv = (import.meta as any).env.NODE_ENV as EnvName;
    return ENV_CONFIGS[nodeEnv];
  }
  